/* rr-bundle: PDP "Buy 2 get X% · Buy 3 get Y%" box with a product picker sheet.
   Slot 1 follows the page's selected variant; slots 2-3 are picked in a bottom sheet (mobile) / modal (desktop).
   Vanilla custom element, no globals. Works on Dawn (HOKA: Kai cart drawer, Dawn cart drawer, pub/sub) and
   Eurus (REV: Alpine mini cart, eurus:* events); every theme hook is optional and guarded. */
(() => {
  if (customElements.get('rr-bundle')) return;

  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const decode = (s) => {
    const ta = document.createElement('textarea');
    ta.innerHTML = String(s == null ? '' : s);
    return ta.value;
  };
  const fill = (s, v) => String(s).replace(/\{(\w+)\}/g, (_, k) => (k in v ? v[k] : ''));
  const reduceMotion = () => window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Dawn-based themes announce cart and variant changes on a pub/sub bus (pubsub.js + constants.js).
  // PUB_SUB_EVENTS is a top-level const there, so it is read by name, not from window.
  const pubsub = () =>
    typeof window.subscribe === 'function' && typeof window.publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : null;

  const PLUS = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M12 5v14M5 12h14"/></svg>';
  const CROSS = (n) => `<svg width="${n}" height="${n}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="${n < 14 ? 3 : 1.8}" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M18 6 6 18M6 6l12 12"/></svg>`;
  const FOCUSABLE = 'button:not([disabled]), a[href], input, [tabindex]:not([tabindex="-1"])';

  class RrBundle extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      const cfgEl = this.querySelector('[data-rr-config]');
      if (!cfgEl) return;
      try {
        this.cfg = JSON.parse(cfgEl.textContent);
      } catch (e) {
        return;
      }
      this._ready = true;
      this.t = this.cfg.i18n || {};
      this.s = {};
      const strings = this.querySelector('template[data-rb-strings]');
      if (strings) strings.content.querySelectorAll('[data-k]').forEach((el) => (this.s[el.dataset.k] = el.textContent.trim()));
      // Products offered per slot: slot 2 from catalog, slot 3 from catalog3 (null = same as slot 2).
      const usable = (list) => (list || []).filter((p) => p && p.variants && p.variants.some((v) => v.available));
      const pair2 = usable(this.cfg.catalog);
      this.catalogs = { 1: pair2, 2: this.cfg.catalog3 ? usable(this.cfg.catalog3) : pair2 };
      this.viewAll = { 1: this.cfg.viewAllUrl, 2: this.cfg.viewAllUrl3 || this.cfg.viewAllUrl };
      this.catalog = pair2;
      // tier3 = 0 means a "Buy 2" only box: two slots.
      this.slots = this.cfg.tier3 > 0 ? [null, null, null] : [null, null];
      this.picking = null;
      this.picked = null;
      this.pickedVariantId = null;
      this.loading = false;

      this.el = {
        nudge: this.querySelector('[data-rb-nudge]'),
        slots: this.querySelector('[data-rb-slots]'),
        total: this.querySelector('[data-rb-total]'),
        was: this.querySelector('[data-rb-was]'),
        sub: this.querySelector('[data-rb-sub]'),
        save: this.querySelector('[data-rb-save]'),
        error: this.querySelector('[data-rb-error]'),
        cta: this.querySelector('[data-rb-cta]')
      };

      const section = this.closest('[id^="shopify-section-"]');
      this.section = section;
      this.sectionId = section ? section.id.replace('shopify-section-', '') : '';

      this.buildSheet();
      this.setCurrent(this.readVariantId() || this.cfg.currentVariantId);
      this.render();

      this.addEventListener('click', (e) => this.onClick(e));
      this.el.cta.addEventListener('click', () => this.addToCart());

      // Slot 1 follows the product form: Dawn updates the id input on change, then publishes variantChange.
      this.onVariant = () => setTimeout(() => {
        const id = this.readVariantId();
        if (id && (!this.slots[0] || this.slots[0].variantId !== id)) {
          this.setCurrent(id);
          this.render();
        }
      }, 0);
      if (section) section.addEventListener('change', this.onVariant);
      window.addEventListener('popstate', this.onVariant);
      // Eurus announces the selected variant per section.
      if (this.sectionId) document.addEventListener('eurus:product-page-variant-select:updated:' + this.sectionId, this.onVariant);
      const ev = pubsub();
      if (ev) {
        this._unsub = window.subscribe(ev.variantChange, (e) => (!e || !e.data || e.data.sectionId === this.sectionId) && this.onVariant());
      }

      if (this.cfg.end > 0) {
        const ms = this.cfg.end * 1000 - Date.now();
        if (ms <= 0) this.hidden = true;
        else if (ms < 2147483647) this._endTimer = setTimeout(() => this.remove(), ms);
      }
    }

    disconnectedCallback() {
      if (!this._ready) return;
      clearTimeout(this._endTimer);
      if (this.section) this.section.removeEventListener('change', this.onVariant);
      window.removeEventListener('popstate', this.onVariant);
      if (this.sectionId) document.removeEventListener('eurus:product-page-variant-select:updated:' + this.sectionId, this.onVariant);
      if (typeof this._unsub === 'function') this._unsub();
      if (this.sheet && this.sheet.parentNode) this.sheet.remove();
      this.unlockScroll();
      this._ready = false;
    }

    // ---------- money / math ----------

    money(cents) {
      const n = (Math.max(0, Math.round(cents)) / 100).toLocaleString('th-TH', { maximumFractionDigits: 0 });
      return String(this.cfg.moneyFormat || '฿{{amount}}').replace(/\{\{\s*\w+\s*\}\}/, n).replace(/<[^>]*>/g, '');
    }
    get count() {
      return this.slots.filter(Boolean).length;
    }
    rateFor(n) {
      if (n >= 3 && this.cfg.tier3 > 0) return this.cfg.tier3;
      return n >= 2 ? this.cfg.tier2 : 0;
    }
    get rate() {
      return this.rateFor(this.count);
    }
    get subtotal() {
      return this.slots.reduce((a, s) => a + (s ? s.price : 0), 0);
    }
    get discount() {
      return Math.round((this.subtotal * this.rate) / 100);
    }

    // ---------- current product ----------

    // Dawn keeps the selected variant in the product form's id input.
    readVariantId() {
      let input = this.sectionId ? document.getElementById('update-variant-' + this.sectionId) : null;
      if (input && !input.value) input = null;
      if (!input && this.sectionId) {
        const form = document.getElementById('product-form-' + this.sectionId);
        input = form && form.querySelector('input[name="id"]');
      }
      if (!input && this.section) input = this.section.querySelector('form[action*="/cart/add"] [name="id"]');
      const fromInput = input ? parseInt(input.value, 10) : 0;
      const fromUrl = parseInt(new URLSearchParams(location.search).get('variant'), 10) || 0;
      return fromInput || fromUrl;
    }
    makeSlot(p, v) {
      return { productId: p.id, variantId: v.id, title: decode(p.title), image: p.image, label: v.label, price: v.price };
    }
    setCurrent(variantId) {
      const p = this.cfg.current;
      const v = p && p.variants.find((x) => x.id === Number(variantId));
      this.slots[0] = v && v.available ? this.makeSlot(p, v) : null;
    }

    // ---------- box ----------

    render() {
      const n = this.count;
      this.el.nudge.textContent = n <= 1 ? this.t.nudge1 : n < this.slots.length ? this.t.nudge2 : this.t.nudgeMax;

      this.el.slots.innerHTML = this.slots
        .map((s, i) => {
          if (s) {
            const remove = i > 0 ? `<button type="button" class="rr-bundle__remove" data-rb-remove="${i}" aria-label="${esc(this.s.remove)}">${CROSS(10)}</button>` : '';
            return `<div class="rr-bundle__slot"><div class="rr-bundle__img">${s.image ? `<img src="${esc(s.image)}" alt="${esc(s.title)}" width="64" height="64" loading="lazy">` : ''}</div><span class="rr-bundle__size" title="${esc(s.label)}">${esc(s.label)}</span>${remove}</div>`;
          }
          if (i === 0) return `<div class="rr-bundle__slot"><div class="rr-bundle__img rr-bundle__img--empty"></div></div>`;
          const off = fill(this.t.slotOff, { rate: this.rateFor(i + 1) });
          return `<div class="rr-bundle__slot"><button type="button" class="rr-bundle__empty" data-rb-open="${i}" aria-label="${esc(this.s.addSlot + ' ' + (i + 1))}">${PLUS}</button><span class="rr-bundle__unlock">${esc(off)}</span></div>`;
        })
        .join('');

      const sub = this.subtotal;
      this.el.total.textContent = this.money(sub - this.discount);
      this.el.was.hidden = this.rate === 0;
      this.el.sub.textContent = this.money(sub);
      this.el.save.textContent = this.money(this.discount);

      const ok = n >= 2 && !this.loading;
      this.el.cta.disabled = !ok;
      this.el.cta.textContent = this.loading ? this.t.adding : n < 2 ? this.t.ctaMin : fill(this.t.ctaAdd, { n, rate: this.rate });
    }

    onClick(e) {
      const open = e.target.closest('[data-rb-open]');
      if (open) return this.open(parseInt(open.dataset.rbOpen, 10));
      const rm = e.target.closest('[data-rb-remove]');
      if (rm) {
        const i = parseInt(rm.dataset.rbRemove, 10);
        this.slots[i] = null;
        this.showError('');
        this.render();
        const btn = this.querySelector(`[data-rb-open="${i}"]`);
        if (btn) btn.focus();
      }
    }

    showError(msg) {
      this.el.error.textContent = msg || '';
      this.el.error.hidden = !msg;
    }

    // ---------- sheet ----------

    buildSheet() {
      const id = this.dataset.uid || 'rr-bundle';
      const sheet = document.createElement('div');
      sheet.className = 'rr-bundle-modal';
      sheet.hidden = true;
      sheet.innerHTML = `
        <div class="rr-bundle-modal__panel" role="dialog" aria-modal="true" aria-labelledby="${esc(id)}-title">
          <div class="rr-bundle-modal__head">
            <div>
              <h3 class="rr-bundle-modal__title" id="${esc(id)}-title" data-rb-pick-title></h3>
              <span class="rr-bundle-modal__sub" data-rb-pick-sub></span>
            </div>
            <button type="button" class="rr-bundle-modal__close" data-rb-close aria-label="${esc(this.s.close)}">${CROSS(20)}</button>
          </div>
          <div class="rr-bundle-modal__body" data-rb-body>
            <div class="rr-bundle-modal__grid" data-rb-grid></div>
            <div class="rr-bundle-modal__size-wrap" data-rb-size-wrap hidden>
              <p class="rr-bundle-modal__label">${esc(this.s.size)}</p>
              <div class="rr-bundle-modal__sizes" data-rb-sizes></div>
            </div>
            <a class="rr-bundle-modal__all" data-rb-all href="#">${esc(this.s.viewAll)}</a>
          </div>
          <div class="rr-bundle-modal__foot">
            <button type="button" class="rr-bundle-modal__confirm" data-rb-confirm disabled></button>
          </div>
        </div>`;
      // The sheet is fixed to the screen, so it lives on <body>, out of any transformed product column.
      document.body.appendChild(sheet);
      this.sheet = sheet;
      this.sh = {
        title: sheet.querySelector('[data-rb-pick-title]'),
        sub: sheet.querySelector('[data-rb-pick-sub]'),
        body: sheet.querySelector('[data-rb-body]'),
        grid: sheet.querySelector('[data-rb-grid]'),
        sizeWrap: sheet.querySelector('[data-rb-size-wrap]'),
        sizes: sheet.querySelector('[data-rb-sizes]'),
        confirm: sheet.querySelector('[data-rb-confirm]'),
        all: sheet.querySelector('[data-rb-all]')
      };
      sheet.addEventListener('click', (e) => this.onSheetClick(e));
      sheet.addEventListener('keydown', (e) => this.onSheetKey(e));
    }

    fromPrice(p) {
      const prices = p.variants.filter((v) => v.available).map((v) => v.price);
      return this.money(prices.length ? Math.min.apply(null, prices) : p.variants[0].price);
    }

    open(i) {
      this.picking = i;
      this.picked = null;
      this.pickedVariantId = null;
      this.sh.title.textContent = fill(this.t.pickTitle, { n: i + 1 });
      this.sh.sub.textContent = fill(this.t.pickSub, { rate: this.rateFor(this.count + 1) });
      this.catalog = this.catalogs[i] || this.catalogs[1];
      const all = this.viewAll[i] || this.viewAll[1];
      this.sh.all.hidden = !all;
      if (all) this.sh.all.href = all;
      this.sh.grid.innerHTML = this.catalog
        .map(
          (p) => `<button type="button" class="rr-bundle-modal__card" data-rb-product="${p.id}" aria-pressed="false">
            <span class="rr-bundle-modal__thumb">${p.image ? `<img src="${esc(p.image)}" alt="" loading="lazy">` : ''}</span>
            <span class="rr-bundle-modal__name">${esc(decode(p.title))}</span>
            <span class="rr-bundle-modal__price">${esc(this.fromPrice(p))}</span>
          </button>`
        )
        .join('');
      this.renderSizes();
      this.sh.body.scrollTop = 0;
      this._returnFocus = document.activeElement;
      this.sheet.hidden = false;
      this.lockScroll();
      requestAnimationFrame(() => {
        this.sheet.classList.add('is-open');
        const close = this.sheet.querySelector('[data-rb-close]');
        if (close) close.focus();
      });
    }

    close() {
      if (this.sheet.hidden) return;
      const returnTo = this.picking;
      this.picking = null;
      this.sheet.classList.remove('is-open');
      this.sheet.hidden = true;
      this.unlockScroll();
      const btn = this.querySelector(`[data-rb-open="${returnTo}"]`) || this._returnFocus;
      if (btn && btn.focus) btn.focus();
    }

    renderSizes() {
      const p = this.picked;
      this.sh.grid.querySelectorAll('[data-rb-product]').forEach((b) => {
        const on = p && String(p.id) === b.dataset.rbProduct;
        b.classList.toggle('is-selected', !!on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      this.sh.sizeWrap.hidden = !p;
      this.sh.sizes.innerHTML = p
        ? p.variants
            .map(
              (v) =>
                `<button type="button" class="rr-bundle-modal__size${this.pickedVariantId === v.id ? ' is-selected' : ''}" data-rb-variant="${v.id}" title="${esc(v.label)}" aria-pressed="${this.pickedVariantId === v.id}"${v.available ? '' : ' disabled'}>${esc(v.label)}</button>`
            )
            .join('')
        : '';
      const v = p && this.pickedVariantId ? p.variants.find((x) => x.id === this.pickedVariantId) : null;
      this.sh.confirm.disabled = !v;
      this.sh.confirm.textContent = v ? fill(this.t.confirm, { size: v.label }) : p ? this.t.chooseSize : this.t.choose;
    }

    onSheetClick(e) {
      if (e.target === this.sheet || e.target.closest('[data-rb-close]')) return this.close();
      const card = e.target.closest('[data-rb-product]');
      if (card) {
        this.picked = this.catalog.find((p) => String(p.id) === card.dataset.rbProduct) || null;
        const avail = this.picked ? this.picked.variants.filter((v) => v.available) : [];
        this.pickedVariantId = avail.length === 1 ? avail[0].id : null;
        this.renderSizes();
        // Bring the size buttons into view and flash their label once.
        requestAnimationFrame(() => {
          const body = this.sh.body;
          const wrap = this.sh.sizeWrap;
          const top = body.scrollTop + (wrap.getBoundingClientRect().top - body.getBoundingClientRect().top) - 12;
          body.scrollTo({ top: Math.max(0, top), behavior: reduceMotion() ? 'auto' : 'smooth' });
          wrap.classList.remove('is-flash');
          void wrap.offsetWidth;
          wrap.classList.add('is-flash');
        });
        return;
      }
      const size = e.target.closest('[data-rb-variant]');
      if (size && !size.disabled) {
        this.pickedVariantId = parseInt(size.dataset.rbVariant, 10);
        this.renderSizes();
        return;
      }
      if (e.target.closest('[data-rb-confirm]')) this.confirm();
    }

    onSheetKey(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        return this.close();
      }
      if (e.key !== 'Tab') return;
      const items = Array.from(this.sheet.querySelectorAll(FOCUSABLE)).filter((el) => el.offsetParent !== null);
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    confirm() {
      const p = this.picked;
      const v = p && p.variants.find((x) => x.id === this.pickedVariantId);
      if (!v || this.picking === null) return;
      this.slots[this.picking] = this.makeSlot(p, v);
      this.showError('');
      this.render();
      this.close();
    }

    lockScroll() {
      if (this._locked) return;
      this._locked = true;
      document.documentElement.classList.add('rr-bundle-lock');
    }
    unlockScroll() {
      if (!this._locked) return;
      this._locked = false;
      document.documentElement.classList.remove('rr-bundle-lock');
    }

    // ---------- cart ----------

    async addToCart() {
      if (this.count < 2 || this.loading) return;
      this.loading = true;
      this.showError('');
      this.render();
      const items = this.slots.filter(Boolean).map((s) => ({ id: s.variantId, quantity: 1, properties: { _bundle: this.cfg.bundleTag } }));
      const drawer = document.querySelector('cart-drawer');
      const kai = window.KaiCartDrawer && window.KaiCartDrawer.active ? window.KaiCartDrawer : null;
      const body = { items };
      if (!kai && drawer && typeof drawer.getSectionsToRender === 'function') {
        body.sections = drawer.getSectionsToRender().map((s) => s.id);
        body.sections_url = location.pathname;
      }
      const root = this.cfg.root || '/';
      let data = null;
      try {
        const res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });
        data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || this.t.error);
      } catch (e) {
        this.loading = false;
        this.render();
        this.showError((e && e.message) || this.t.error);
        return;
      }
      this.loading = false;
      this.slots = this.slots.map((s, i) => (i === 0 ? s : null));
      this.render();
      this.dispatchEvent(new CustomEvent('rr:bundle:added', { bubbles: true, detail: { items, rate: this.rateFor(items.length) } }));
      this.openCart(data, drawer, kai);
    }

    openCart(data, drawer, kai) {
      const ev = pubsub();
      if (ev) {
        try {
          window.publish(ev.cartUpdate, { source: 'rr-bundle', cartData: data });
        } catch (e) {}
      }
      // Kai's cart drawer replaces the theme drawer on HOKA: let it re-read the cart and open itself.
      if (kai) {
        Promise.resolve(typeof kai.refresh === 'function' ? kai.refresh() : null)
          .catch(() => {})
          .then(() => typeof kai.open === 'function' && !(typeof kai.isOpen === 'function' && kai.isOpen()) && kai.open());
        return;
      }
      const A = window.Alpine;
      const mini = A && typeof A.store === 'function' ? A.store('xMiniCart') : null;
      if (mini) {
        document.documentElement.classList.remove('rr-bundle-lock');
        if (typeof mini.reLoad === 'function') mini.reLoad();
        else mini.needReload = true;
        try {
          document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
        } catch (e) {}
        // Open through the header cart icon, so Eurus runs its own open/close cycle and unlocks page scroll.
        const trigger = document.querySelector('header a[href$="/cart"], header [aria-controls*="cart" i], #cart-icon-bubble, [data-cart-trigger]');
        if (trigger) setTimeout(() => trigger.click(), 250);
        else if (typeof mini.openCart === 'function') setTimeout(() => mini.openCart(), 250);
        return;
      }
      if (drawer && typeof drawer.renderContents === 'function' && data && data.sections) {
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
        return;
      }
      const note = document.querySelector('cart-notification');
      if (note && typeof note.renderContents === 'function' && data && data.sections) {
        note.renderContents(data);
        return;
      }
      location.href = this.cfg.cartUrl || '/cart';
    }
  }

  customElements.define('rr-bundle', RrBundle);
})();
